import Vue from 'vue'
import Vuex from 'vuex' 

Vue.use(Vuex)

const store = new Vuex.Store({
    state:{  //设置全局访问的对象
        headerMenuIndex:0,
    },
    getters:{ //实时监听state值的变化（最新状态）
        getHeaderIndex(state){
            return state.headerMenuIndex
        },
    },
    mutations:{ //唯一允许更改state
        changeHeaderIndex(state,index){
            state.headerMenuIndex = index;
        }
    },
    actions:{ //触发更改
        // getHeaderIndex(context,index){console.log(context,index)
        //     context.commit('changeHeaderIndex',index)
        // },
    },
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js